import type {IFoodInfo} from '../pages/food_info/types';
import {create} from 'zustand/react';

interface IFoodStore {
    selectedFoodInfo: IFoodInfo | undefined;
    setFoodInfo: (val: IFoodInfo) => void;
}

const useFoodStore = create<IFoodStore>((set, get) => ({
    selectedFoodInfo: undefined,
    setFoodInfo: (val) => {
        set({selectedFoodInfo: val});
    },
}));

export default useFoodStore;
